<!--
  @description: 发票管理-详情
  @filePath:src/modules/transport/bms/views/finance/invoiceManage/details.vue
-->
<template>
    <paper class="invoice-manage-details finance-detail">
        <div class="content" v-loading="loading">
            <!-- 顶部操作按钮 -->
            <div class="buttons">
                <el-button @click="goLists">返 回</el-button>
                <el-button type="primary" @click="handleAddInvoice" :disabled="!isUsaAddInvoice" v-has="'07080001'"  v-show="true">新增发票</el-button>
                <el-button type="primary" @click="handleSaveInvoice" :disabled="!isUsableSaveInvoice" v-has="'07080002'" v-show="isUsableSaveInvoice" :loading="saveInvoiceLoading">保存发票头</el-button>
                <el-button type="primary" @click="handleDeleteInvoice" :disabled="!isUsableDeleteInvoice" v-has="'07080003'" v-show="isUsableSaveInvoice" :loading="deleteInvoiceLoading">删除发票</el-button>
                <el-button type="primary" @click="handleInfoConfirm" :disabled="!isUsableInfoConfirm" v-has="'07080004'" v-show="isUsableInfoConfirm" :loading="infoConfirmLoading">信息确认</el-button>
                <el-button type="primary" @click="handleCancelInfoConfirm" :disabled="!isUsableCancelInfoConfirm" v-has="'07080005'" v-show="isUsableCancelInfoConfirm" :loading="cancelInfoConfirmLoading">取消信息确认</el-button>
                <el-button type="primary" @click="handleInvoicePreview" :disabled="!isUsableInvoicePreview" v-has="'07080006'" v-show="isUsableInvoicePreview">发票预览</el-button>
                <el-button type="primary" @click="handleSubmitInvoice" :disabled="!isUsableSubmitInvoice" v-has="'07080007'" v-show="isUsableSubmitInvoice" :loading="submitInvoiceLoading">提交开票</el-button>
                <el-button type="primary" @click="handleRedOffsetInvoice" :disabled="!isUsableRedOffsetInvoice" v-has="'07080008'" :loading="redOffsetInvoiceLoading">红冲发票</el-button>
                <el-button type="primary" @click="handleReopenInvoice" :disabled="!isUsableReopenInvoice" v-has="'07080009'" :loading="reopenInvoiceLoading">重开发票</el-button>
                <el-button type="primary" @click="handlePrevPage" :disabled="!isUsablePrevPage" v-show="true">上一张</el-button>
                <el-button type="primary" @click="handleNextPage" :disabled="!isUsableNextPage" v-show="true">下一张</el-button>
                <div class="invoice-page-num" v-show="!loading">
                    第<span class="current-page">{{ invoicePageNum }}</span>张
                    <span class="slash">/</span>
                    结算申请发票总数共<span class="total-pages">{{ invoicePageTotal }}</span>张
                </div>
            </div>

            <!-- 分割线 -->
            <div class="line"></div>

            <!-- 发票面板 -->
            <el-tabs v-model="activeTabName">
                <el-tab-pane lazy v-show="!loading" v-for="item in invoiceList" :key="item.uuid" :label="item.apApplyNo" :name="item.uuid">
                    <Invoice v-show="activeTabName === item.uuid" :ref="('invoice_'+ item.uuid)" :invoiceData="item" :key="item.uuid" :uuid="item.uuid" :invoiceLabel="item.invoiceLabel"/>
                </el-tab-pane>
            </el-tabs>

            <!-- 发票预览 -->
            <preview-invoice ref="previewInvoice" :invoiceLabel="curInvoiceData.invoiceLabel" :previewInfo="previewInfo"></preview-invoice>
        </div>
    </paper>
</template>

<script>
import Paper from '@/components/core/paper/Paper';
import Invoice from './components/Invoice/index.vue';
import PreviewInvoice from './components/Invoice/PreviewInvoice/index.vue';
import utils from '@/components/utils/common.js';
import { del, stAi } from '@/modules/transport/bms/components/judge/bmsModular';
import {
    saveExtsysInvoice,
    extsysInvoiceQuery,
    deleteExtsysInvoice,
    confirmExtsysInvoice,
    confirmExtsysInvoiceCancel,
    submitExtsysInvoice,
    rushExtsysInvoice,
    remakeExtsysInvoice
} from '@/modules/transport/bms/api/invoiceManageApi.js';
import { removeEditRecord, isEdit, setEditRecord } from './utils.js';
export default {
    name: 'InvoiceManageDetails',
    provide() {
        return {
            updateInvoice: this.updateInvoice
        };
    },
    components: { Paper, Invoice, PreviewInvoice },
    data() {
        return {
            loading: false,
            apApplyData: null, // 结算申请单数据
            activeTabName: '',
            invoicePageNum: 1,
            invoiceList: [],
            curInvoiceNo: '',
            curInvoiceData: {},
            previewInfo: {},
            deleteInvoiceLoading: false,
            saveInvoiceLoading: false,
            infoConfirmLoading: false,
            cancelInfoConfirmLoading: false,
            submitInvoiceLoading: false,
            redOffsetInvoiceLoading: false,
            reopenInvoiceLoading: false
        };
    },
    computed: {
        invoicePageTotal: function () {
            return this.invoiceList.length;
        },
        isUsablePrevPage: function () {
            return (this.invoicePageNum > 1);
        },
        isUsableNextPage: function () {
            return (this.invoicePageNum < this.invoiceList.length);
        },
        isUsaAddInvoice: function () {
            // 单据状态为“新建”,结算申请单号不能为空
            const usable = [10, '10'].includes(this.curInvoiceData.makeInvoiceStatus) && this.curInvoiceData.apApplyNo;
            return usable;
        },
        isUsableSaveInvoice: function () {
            // 单据状态为“新建”
            const usable = [10, '10'].includes(this.curInvoiceData.makeInvoiceStatus);
            return usable;
        },
        isUsableDeleteInvoice: function () {
            // 单据状态为“新建、待开票”
            const usable = [10, '10', 20, '20'].includes(this.curInvoiceData.makeInvoiceStatus);
            return usable;
        },
        isUsableInfoConfirm: function () {
            // 单据状态为“新建”
            const usable = [10, '10'].includes(this.curInvoiceData.makeInvoiceStatus);
            return usable;
        },
        isUsableCancelInfoConfirm: function () {
            // 单据状态为“待开票、开票失败”
            const usable = [20, '20', 50, '50'].includes(this.curInvoiceData.makeInvoiceStatus);
            return usable;
        },
        isUsableSubmitInvoice: function () {
            // 单据状态为“待开票、开票失败”
            const usable = [20, '20', 50, '50'].includes(this.curInvoiceData.makeInvoiceStatus);
            return usable;
        },
        isUsableInvoicePreview: function () {
            // 单据状态为“待开票”
            const usable = [20, '20'].includes(this.curInvoiceData.makeInvoiceStatus);
            return usable;
        },
        isUsableRedOffsetInvoice: function () {
            /**
             * description 红冲发票按钮-可操作场景
             *  分两种情况：
             *   一丶情况一满足如下条件：
             *      1、“红冲发票申请单号”的MIP流程为审批通过 (后端判断);
             *      2、结算申请单的“记账状态”为记账成功 (后端判断);
             *      3、按照原蓝票号查询发票接口表不存在红冲的发票 (后端判断);
             *      4、开票状态(invoiceType)为“待红冲（60）”
             *   二丶情况二满足如下条件：
             *      1、发票的“结算申请单号(apApplyNo)”为空；
             *      2、“已同步结算申请单号(hasSynchApply)”为空或否；
             *      3、开票状态(makeInvoiceStatus)为“已开票(40)” - 字典表code：BMS_AP_OPEN_INVOICE_STATUS；
             *      4、发票类型(invoiceType)为“全电专票（蓝字）(15)” 或 “全电普票(17) ” - 字典表code：SYS_SC_INVOICE_TYPE_BMS；
             */

            const usable1 = [60, '60'].includes(this.curInvoiceData.makeInvoiceStatus);
            const usable2 =
            !this.curInvoiceData.apApplyNo &&
            !this.curInvoiceData.hasSynchApply &&
            [40, '40'].includes(this.curInvoiceData.makeInvoiceStatus) &&
            [15, '15', 17, '17'].includes(this.curInvoiceData.invoiceType);
            return (usable1 || usable2);
        },
        isUsableReopenInvoice: function () {
            /**
             * description 重开发票按钮-可操作场景
             * 1、发票类型为“全电专票（蓝字）(15)” 或 “全电普票(17) ” - 字典表code：SYS_SC_INVOICE_TYPE_BMS；
             * 2、发票状态为“已红冲(80)” 或 “红冲后待开(90)” - 字典表code：BMS_AP_OPEN_INVOICE_STATUS；
             */
            const usable =
            [15, '15', 17, '17'].includes(this.curInvoiceData.invoiceType) &&
            [80, '80', 90, '90'].includes(this.curInvoiceData.makeInvoiceStatus);
            return usable;
        }
    },
    methods: {
        // 返回
        goLists() { this.$router.push({ path: `/bms/invoiceManage`, query: { refreshList: true } }); },
        // 新增发票
        handleAddInvoice(triggerName) {
            if (this.isEditHeader()) return;
            const temp = {
                'apApplyNo': '',
                'buyerName': '',
                'buyerTaxNo': '',
                'buyerAddress': '',
                'buyerPhone': '',
                'buyerBankName': '',
                'buyerBankAccount': '',
                'sellerName': '',
                'sellerTaxNo': '',
                'sellerAddress': '',
                'sellerPhone': '',
                'sellerBankName': '',
                'sellerBankAccount': ''
            };
            const addData = {
                uuid: utils.uuid(),
                ...stAi(this.apApplyData, temp),
                'ifShowBuyer': 0, // 默认不展示购方
                'ifShowSeller': 0, // 默认不展示销方
                'makeInvoiceStatus': '10', // 开票状态默认-新建
                'invoiceType': '15' // 发票类型默认-全电专票
            };
            triggerName === 'init' ? (addData.invoiceLabel = this.apApplyData.invoiceLabel) : (addData.invoiceLabel = '10'); // 发票标签默认-货物运输服务
            this.invoiceList.push(addData);
            this.activeTabName = addData.uuid;
        },
        // 保存发票
        handleSaveInvoice() {
            let saveData = {
                ...this.curInvoiceData,
                ...this.getCurInvoiceHeaderData()
            };
            saveData = del(saveData, ['uuid', 'skr', 'fhr']);
            this.saveInvoiceLoading = true;
            saveExtsysInvoice(saveData).then(res => {
                if (res && res.code === '0') {
                    const resData = res.data.data || res.data;
                    this.invoiceList.forEach((el, i) => {
                        if (el.uuid === this.curInvoiceData.uuid) {
                            const newVal = {
                                ...el,
                                ...saveData,
                                ...resData
                            }; // 加...saveData的原因是后端不会返回为空低字段,需要覆盖已经清空的字段
                            this.invoiceList.splice(i, 1, newVal);
                            this.curInvoiceData = { ...this.curInvoiceData, ...newVal };
                        }
                    });
                    this.$message.success('保存成功!');
                }
            }).finally(() => {
                this.saveInvoiceLoading = false;
            });
        },
        // 删除发票
        handleDeleteInvoice() {
            this.$confirm('请确认是否删除当前发票?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const deleteSuccessCallBack = () => {
                    const len = this.invoiceList.length;
                    if (!len) return;
                    this.invoiceList.splice(this.invoicePageNum - 1, 1);
                    this.invoicePageNum = this.invoiceList.length ? 1 : 0;
                    this.activeTabName = this.invoiceList[0].uuid;
                    this.$message.success('删除成功!');
                };
                if (this.curInvoiceData.jobId) {
                    this.deleteInvoiceLoading = true;
                    deleteExtsysInvoice([this.curInvoiceData.jobId]).then(res => {
                        if (res && res.code === '0') {
                            deleteSuccessCallBack();
                        }
                    }).finally(() => {
                        this.deleteInvoiceLoading = false;
                    });
                } else {
                    deleteSuccessCallBack();
                }
            });
        },
        // 信息确认
        handleInfoConfirm() {
            if (this.isEditHeader()) return;
            if (!this.curInvoiceData.sysInvoiceNo) return;
            if (!this.checkInvoiceHasData()) return;
            this.infoConfirmLoading = true;
            confirmExtsysInvoice({ sysInvoiceNo: this.curInvoiceData.sysInvoiceNo }).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('信息确认成功!');
                    this.updateInvoice();
                }
            }).finally(() => {
                this.infoConfirmLoading = false;
            });
        },
        // 取消信息确认
        handleCancelInfoConfirm() {
            if (!this.curInvoiceData.sysInvoiceNo) return;
            this.cancelInfoConfirmLoading = true;
            confirmExtsysInvoiceCancel({ sysInvoiceNo: this.curInvoiceData.sysInvoiceNo }).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('信息已取消确认!');
                    this.updateInvoice();
                }
            }).finally(() => {
                this.cancelInfoConfirmLoading = false;
            });
        },
        // 提交开票
        handleSubmitInvoice() {
            if (!this.curInvoiceData.sysInvoiceNo) return;
            this.$confirm('请确认已在24小时内智汇票系统登录再提交开票。', '提交开票提示:', {
                confirmButtonText: '已登录',
                cancelButtonText: '未登录',
                type: 'warning'
            }).then(() => {
                this.submitInvoiceLoading = true;
                submitExtsysInvoice({ sysInvoiceNo: this.curInvoiceData.sysInvoiceNo }).then(res => {
                    if (res && res.code === '0') {
                        this.$message.success('提交开票成功!');
                        this.updateInvoice();
                    }
                }).finally(() => {
                    this.submitInvoiceLoading = false;
                });
            });
        },
        // 红冲
        handleRedOffsetInvoice() {
            if (this.isEditHeader()) return;
            if (!this.curInvoiceData.sysInvoiceNo) return;
            this.redOffsetInvoiceLoading = true;
            rushExtsysInvoice([ this.curInvoiceData.sysInvoiceNo ]).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('发票红冲成功!');
                    this.updateInvoice();
                }
            }).finally(() => {
                this.redOffsetInvoiceLoading = false;
            });
        },
        // 重开
        handleReopenInvoice() {
            if (this.isEditHeader()) return;
            if (!this.curInvoiceData.sysInvoiceNo) return;
            this.reopenInvoiceLoading = true;
            remakeExtsysInvoice({ sysInvoiceNo: this.curInvoiceData.sysInvoiceNo }).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('发票重开成功!');
                    extsysInvoiceQuery({ pageNo: 1, pageSize: 9999, oldInvoiceNo: this.curInvoiceData.sysInvoiceNo }).then(res => {
                        if (res && +res.code === 0 && res.data.list.length) {
                            const reopenInvoiceData = res.data.list[0];
                            this.$router.push({ path: `/bms/invoiceManage`,
                                query: { redirectName: 'InvoiceManageDetails',
                                    redirectParams: JSON.stringify({
                                        ...reopenInvoiceData
                                    })
                                } });
                        }
                    });
                }
            }).finally(() => {
                this.reopenInvoiceLoading = false;
            });
        },
        // 预览
        handleInvoicePreview() {
            if (this.isEditHeader()) return;
            this.previewInfo = {
                ...this.curInvoiceData,
                invoiceDetails: this.$refs['invoice_' + this.curInvoiceData.uuid][0].getInvoiceDetailData(),
                invoiceContent: this.$refs['invoice_' + this.curInvoiceData.uuid][0].getInvoiceContentData()
            };
            this.$refs.previewInvoice.show(this.curInvoiceData.invoiceLabel);
        },
        // 上一页
        handlePrevPage() {
            if (this.isEditHeader()) return;
            let index = this.invoicePageNum - 1;
            index > 0 && --index;
            this.activeTabName = this.invoiceList[index].uuid;
        },
        // 下一页
        handleNextPage() {
            if (this.isEditHeader()) return;
            let index = this.invoicePageNum - 1;
            this.invoicePageNum < this.invoicePageTotal && ++index;
            this.activeTabName = this.invoiceList[index].uuid;
        },
        // 获取当前发票头的数据
        getCurInvoiceHeaderData() {
            const curUuid = this.curInvoiceData.uuid;
            const invoiceRef = this.$refs['invoice_' + curUuid][0] || this.$refs['invoice_' + curUuid];
            return invoiceRef.$refs['invoiceHeaderTable_' + curUuid].infoData;
        },
        // 查询发票信息
        queryInvoice() {
            this.loading = true;
            return extsysInvoiceQuery({ pageNo: 1, pageSize: 9999, apApplyNo: this.apApplyData.apApplyNo }).then(res => {
                if (res && +res.code === 0) {
                    const data = res.data;
                    this.invoiceList = data.list.map(el => {
                        return {
                            uuid: utils.uuid(),
                            ...el
                        };
                    });
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        // 更新发票信息
        updateInvoice(fields = [], callback) {
            this.loading = true;
            return extsysInvoiceQuery({ pageNo: 1, pageSize: 9999, sysInvoiceNo: this.curInvoiceData.sysInvoiceNo, apApplyNo: this.apApplyData.apApplyNo }).then(res => {
                if (res && +res.code === 0) {
                    const data = res.data.list[0] || {};
                    this.invoiceList.forEach((el, i) => {
                        if (el.sysInvoiceNo === this.curInvoiceData.sysInvoiceNo) {
                            if (fields.length) {
                                // 指定字段更新
                                fields.forEach(field => {
                                    this.curInvoiceData[field] = data[field];
                                    el[field] = data[field];
                                });
                            } else {
                                // 全量更新
                                el = {
                                    ...el,
                                    ...data
                                };
                                this.invoiceList.splice(i, 1, el);
                                this.curInvoiceData = el;
                            }
                        }
                    });
                    sessionStorage.setItem('apApplyData', JSON.stringify(this.curInvoiceData));
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        isEditHeader() {
            const flag = isEdit('header');
            flag && this.$message.warning('请先保存发票头!');
            return flag;
        },
        checkInvoiceHasData() {
            let flag = true;
            const curUuid = this.curInvoiceData.uuid;
            const invoiceRef = this.$refs['invoice_' + curUuid][0] || this.$refs['invoice_' + curUuid];
            const invoiceDetailRef = invoiceRef.$refs['invoiceDetailTable_' + curUuid];
            const invoiceContentRef = invoiceRef.$refs['invoiceContentTable_' + curUuid];
            if (!invoiceDetailRef.hasData) {
                flag = false;
                this.$message.warning('发票明细要不为空');
            } else if (!['30', 30].includes(this.curInvoiceData.invoiceLabel) && !invoiceContentRef.hasData) {
                flag = false;
                this.$message.warning('发票内容要不为空');
            } else if (!invoiceDetailRef.$refs.tablePage.$refs.table.$refs.mNewTable.tableExamine(invoiceDetailRef.totalData)) {
                flag = false;
            } else if (!['30', 30].includes(this.curInvoiceData.invoiceLabel) && !invoiceContentRef.$refs.tablePage.$refs.table.$refs.mNewTable.tableExamine(invoiceContentRef.totalData)) {
                flag = false;
            };
            return flag;
        },
        _beforeunloadHandler(event) {
            if (isEdit()) {
                window.removeEventListener('beforeunload');
                sessionStorage.removeItem('isEdit-InvoiceManageDetails');
                event.preventDefault();
                event.returnValue = '您在页面编辑了未保存，是否确认离开';
                return '您在页面编辑了未保存，是否确认离开';
            }
        }
    },
    watch: {
        $route: {
            immediate: true,
            async handler({ name, params, query }, oldValue) {
                if (name === 'InvoiceManageDetails') {
                    try {
                        this.apApplyData = JSON.parse(params.apApplyData || sessionStorage.getItem('apApplyData')) || {};
                        sessionStorage.setItem('apApplyData', JSON.stringify(this.apApplyData));
                        const curSysInvoiceNo = this.apApplyData.sysInvoiceNo;
                        const curApApplyNo = this.apApplyData.apApplyNo;
                        const makeInvoiceStatus = this.apApplyData.makeInvoiceStatus;
                        const isCancellation = !curApApplyNo || ([80, '80'].includes(makeInvoiceStatus)); // 是否作废
                        if (isCancellation) {
                            /**
                             * 结算申请单作废了,该发票没有申请单号的
                             */
                            const addInvoiceData = {
                                uuid: utils.uuid(),
                                ...this.apApplyData
                            };
                            this.invoiceList = [ addInvoiceData ];
                        } else if (query.hasInvoice) {
                            /**
                             * 有发票
                             *  1.调用发票查询接口,查出所有关联该结算申请单的发票
                             *  2.缓存头部信息
                             */
                            await this.queryInvoice();
                            this.invoiceList.length === 1 &&
                            (this.apApplyData = { ...this.invoiceList[0], ...this.apApplyData }) &&
                            sessionStorage.setItem('apApplyData', JSON.stringify(this.apApplyData));
                        } else {
                            /**
                             * 没有发票
                             *  1.新建一张发票
                             */

                            this.invoiceList = [];
                            setEditRecord('header', false);
                            this.handleAddInvoice('init');
                        }
                        /**
                         * 展示发票
                         *  1.从发票管理跳转过来展示点击的那张发票,否则默认展示第一张
                         */
                        if ((query.source || oldValue.name) === 'InvoiceManage') {
                            const curInvoice = this.invoiceList.find(el => el.sysInvoiceNo === curSysInvoiceNo);
                            curInvoice && (this.activeTabName = curInvoice.uuid);
                        } else {
                            this.invoiceList.length && (this.activeTabName = this.invoiceList[0].uuid);
                        }
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.error(error);
                    }
                }
            }
        },
        activeTabName: {
            immediate: true,
            handler(newValue, oldValue) {
                this.invoiceList.map((el, i) => {
                    if (el.uuid === newValue) {
                        this.curInvoiceData = el;
                        this.invoicePageNum = (i + 1);
                    }
                });
            }
        }
    },
    created() {
        removeEditRecord();
    },
    mounted() {
        window.addEventListener('beforeunload', this._beforeunloadHandler);
    },
    beforeRouteLeave(to, from, next) {
        if (isEdit()) {
            this.$confirm('您在页面编辑了未保存，是否确认离开?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                next();
            });
        } else {
            next();
        }
    },
    beforeDestroy() {
        sessionStorage.removeItem('apApplyData');
    }
};

</script>

<style lang="less">
@import '../../../styles/common.less';
.invoice-manage-details {
    .head {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .el-tabs__header{
        display: none;
    }
    .buttons{
        position: relative;
    }
    .invoice-page-num{
        position: absolute;
        right: 0;
        top: -15px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: auto;
        height: 58px;
        font-family: Arial, sans-serif;
        font-size: 16px;
        color: #333;
        .current-page {
            font-size: 24px;
            font-weight: bold;
            margin: 0 4px;
        }

        .slash {
            font-size: 24px;
            font-weight: bold;
            margin: 0 4px;
            color: #666;
        }

        .total-pages {
            font-size: 24px;
            font-weight: bold;
            margin: 0 4px;
            color: #666;
        }
    }
}

</style>
